import type { ProductBlock } from 'types/cms/blocks';

import type { ProductCtasProps } from '../ProductCtas';

export const mapProductBlockToCtas = (
  productBlock: ProductBlock,
): Omit<ProductCtasProps, 'colorScheme'> => {
  const { product, variants } = productBlock.productWithVariants;
  const { slug } = product;

  return {
    blockId: productBlock._key,
    promoCodes: productBlock.promoCodes,
    purchaseType: productBlock.purchaseType,
    isDiscountHidden: productBlock.isDiscountHidden,
    productOverrides: productBlock.productOverrides,
    product: {
      slug,
      variants,
    },
  };
};
